import { z } from 'zod';
import { FUNNEL_SLUG_REGEX } from '../constants/funnels.constants';

export const editFunnelDetailsSchema = z.object({
    name: z.string().trim().min(1, 'Funnel name is required'),
    slug: z
        .string()
        .trim()
        .min(1, 'Funnel slug is required')
        .regex(FUNNEL_SLUG_REGEX, 'Slug can only contain letters, numbers, and underscores'),
});

export type EditFunnelDetailsFormData = z.infer<typeof editFunnelDetailsSchema>;
